import React, { Suspense, lazy } from "react";
import { FileDown } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { getKommuner } from "@/data/kommuner";

// Code-split @react-pdf/renderer so it is never part of the initial bundle.
const Inner = lazy(() =>
  import("@/components/CommissionerPdf").then((m) => ({ default: m.CommissionerPdfButton }))
);

const Fallback = ({ label }) => (
  <span
    className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-[#1A2E24] px-6 py-3.5 font-medium opacity-80"
    data-testid="commissioner-pdf-btn"
  >
    <FileDown className="h-4 w-4" /> {label}
  </span>
);

export const CommissionerPdfButton = (props) => {
  const { lang } = useLang();
  const L = getKommuner(lang) ? lang : "da";
  // Do not pull the heavy @react-pdf chunk during react-snap prerender.
  if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") {
    return <Fallback label={getKommuner(L).pdfButton} />;
  }
  return (
    <Suspense fallback={<Fallback label={getKommuner(L).pdfButton} />}>
      <Inner {...props} />
    </Suspense>
  );
};
